// import React, { useState } from "react";
// import {
// 	Card,
// 	CardContent,
// 	CardDescription,
// 	CardFooter,
// 	CardHeader,
// 	CardTitle,
// } from "../components/ui/card";
// import {
// 	Table,
// 	TableBody,
// 	TableCaption,
// 	TableCell,
// 	TableFooter,
// 	TableHead,
// 	TableHeader,
// 	TableRow,
// } from "../components/ui/table";
// import { Button } from "../components/ui/button";
// import { format, isValid, parseISO } from "date-fns";

// import {
// 	Sheet,
// 	SheetContent,
// 	SheetDescription,
// 	SheetHeader,
// 	SheetTitle,
// 	SheetTrigger,
// } from "../components/ui/sheet";

// import { useQuery } from "react-query";
// import useAxiosPrivate from "../hooks/useAxiosPrivate";
// import useAuth from "../hooks/useAuth";
// import { useLocation, useNavigate } from "react-router-dom";
// import { Input } from "../components/ui/input";
// import EditClient from "./EditClient";
// import NewClient from "../components/NewClient";
// import { useToast } from "../components/ui/use-toast";
// import { ClipLoader } from "react-spinners";
// import Paginator from "../components/Paginator";
// import { useGetAllClients } from "../migration-api/api-hooks/clients";

// function Client() {
// 	const [open, setOpen] = useState(false);
// 	const [client, setClient] = useState();
// 	const axiosPrivate = useAxiosPrivate();
// 	const { auth } = useAuth();
// 	const navigate = useNavigate();
// 	const [eventList, setEventList] = useState([]);
// 	const location = useLocation();
// 	const { toast } = useToast();
// 	const [currentPage, setCurrentPage] = useState(1);
// 	const [pageCount, setPageCount] = useState(0);

// 	// Fetch all clients
//   	const { data: clientsData, isLoading: isLoadingClients } = useGetAllClients();
//   	const allClients = clientsData?.data || [];

// 	console.log("All Clients:", allClients);

// 	const { isLoading } = useQuery({
// 		queryKey: ["clients", currentPage],
// 		queryFn: () => getAllClientsPaginated(currentPage),
// 		onSuccess: (data) => {
// 			setEventList(data?.data?.data?.row);
// 			setPageCount(data?.data?.data?.pageCount);
// 		},
// 		onError: (error) => {
// 			if (error.code === "ERR_NETWORK") {
// 				navigate("/", { state: { from: location }, replace: true });
// 			} else if (
// 				error.response?.status === 401 ||
// 				error.response?.status === 403
// 			) {
// 				navigate("/", { state: { from: location }, replace: true });
// 			} else {
// 				toast({
// 					variant: "destructive",
// 					title: "Error",
// 					description: `${error?.response?.data?.message}`,
// 				});
// 			}
// 		},
// 		refetchOnMount: true,
// 		refetchOnWindowFocus: false,
// 	});

// 	const onPageChange = (page) => {
// 		setCurrentPage(page);
// 	};

// 	const getAllClientsPaginated = async (page) => {
// 		return await axiosPrivate.get(
// 			`client/table/?currentPage=${page}&clients=${auth.user.userClients}`
// 		);
// 	}

// 	function handleDate(date) {
// 		if (date == null) return "N/A";
// 		const validDate = parseISO(date, "yyyy-MM-dd", new Date());
// 		if (isValid(validDate))
// 			return format(new Date(date), "yyyy-MM-dd hh:mm:ss");
// 		return "N/A";
// 	}

// 	const handleEdit = (e, event) => {
// 		e.preventDefault();
// 		setClient(event);
// 		setOpen(true);
// 	};

// 	return (
// 		<>
// 			<Sheet open={open} onOpenChange={setOpen}>
// 				<SheetContent>
// 					<SheetHeader>
// 						<SheetTitle>Edit Client Profile</SheetTitle>
// 						<SheetDescription>
// 							<EditClient client={client} />
// 						</SheetDescription>
// 					</SheetHeader>
// 				</SheetContent>
// 			</Sheet>
// 			<div className=" overflow-hidden">
// 				<Card>
// 					<CardHeader>
// 						<CardTitle className="my-[10px]">
// 							List of all clients
// 						</CardTitle>
// 						<CardDescription className="flex gap-[10px] w-[60vw]">
// 							<Input className="w-[80%]" />
// 							<Sheet>
// 								<SheetTrigger asChild>
// 									<Button variant="outline">
// 										New Client
// 									</Button>
// 								</SheetTrigger>
// 								<SheetContent>
// 									<SheetHeader>
// 										<SheetTitle>
// 											Client Onboarding
// 										</SheetTitle>
// 										<SheetDescription>
// 											Search for a registered client
// 											email, then click the submit.
// 										</SheetDescription>
// 									</SheetHeader>
// 									<NewClient />
// 								</SheetContent>
// 							</Sheet>
// 						</CardDescription>
// 					</CardHeader>
// 					<CardContent className="space-y-2">
// 						<Table className="">
// 							<TableCaption>
// 								A list of All Available clients
// 							</TableCaption>
// 							<TableHeader>
// 								<TableRow>
// 									<TableHead className="">
// 										Client Name
// 									</TableHead>
// 									<TableHead>Date</TableHead>
// 									<TableHead className="text-center">
// 										IS NAFDAC MANDATE
// 									</TableHead>
// 									<TableHead className="text-right">
// 										Trade Partner
// 									</TableHead>
// 								</TableRow>
// 							</TableHeader>
// 							<TableBody>
// 								{isLoading && (
// 									<TableRow>
// 										<TableCell colSpan={7}>
// 											<div className="h-[20vh] place-content-center text-center">
// 												<ClipLoader />
// 											</div>
// 										</TableCell>
// 									</TableRow>
// 								)}
// 								{!isLoading &&
// 									eventList.map((event) => (
// 										<TableRow key={event.id}>
// 											<TableCell className="font-medium  ">
// 												{event?.name}
// 											</TableCell>
// 											<TableCell>
// 												{handleDate(event?.createdAt)}
// 											</TableCell>
// 											<TableCell className=" text-center">
// 												{event.isNafdac === 1
// 													? "YES"
// 													: "NO"}
// 											</TableCell>
// 											<TableCell className="text-right">
// 												<Button
// 													variant="link"
// 													onClick={(e) =>
// 														handleEdit(e, event)
// 													}
// 												>
// 													view
// 												</Button>
// 											</TableCell>
// 										</TableRow>
// 									))}
// 							</TableBody>
// 							<TableFooter>
// 								<TableRow>
// 									<TableCell colSpan={4}>Total</TableCell>
// 								</TableRow>
// 								<TableRow>
// 									<TableCell colSpan={4}>
// 										{pageCount > 1 && (
// 											<Paginator
// 												currentPage={currentPage}
// 												disabled={isLoading}
// 												onPageChange={onPageChange}
// 												pageCount={pageCount}
// 											/>
// 										)}
// 									</TableCell>
// 								</TableRow>
// 							</TableFooter>
// 						</Table>
// 					</CardContent>
// 					<CardFooter></CardFooter>
// 				</Card>
// 			</div>
// 		</>
// 	);
// }

// export default Client;


//==============================================================================================================================================================================


// import React, { useState } from "react";
// import {
// 	Card,
// 	CardContent,
// 	CardDescription,
// 	CardFooter,
// 	CardHeader,
// 	CardTitle,
// } from "../components/ui/card";
// import {
// 	Table,
// 	TableBody,
// 	TableCaption,
// 	TableCell,
// 	TableFooter,
// 	TableHead,
// 	TableHeader,
// 	TableRow,
// } from "../components/ui/table";
// import { Button } from "../components/ui/button";
// import { format, isValid, parseISO } from "date-fns";
// import {
// 	Sheet,
// 	SheetContent,
// 	SheetDescription,
// 	SheetHeader,
// 	SheetTitle,
// 	SheetTrigger,
// } from "../components/ui/sheet";
// import { Input } from "../components/ui/input";
// import EditClient from "./EditClient";
// import NewClient from "../components/NewClient";
// import { useToast } from "../components/ui/use-toast";
// import { ClipLoader } from "react-spinners";
// import Paginator from "../components/Paginator";
// import { useGetAllClients, useGetClientById } from "../migration-api/api-hooks/clients";
// import { NavLink } from "react-router-dom";
// import useAuth from "../hooks/useAuth";
// import { IoSearchOutline } from "react-icons/io5";

// function Client() {
// 	const [open, setOpen] = useState(false);
// 	const [client, setClient] = useState();
// 	const { toast } = useToast();
// 	const { auth } = useAuth();
	
// 	// Pagination and filter state
// 	const [currentPage, setCurrentPage] = useState(1);
// 	const [searchInput, setSearchInput] = useState("");
// 	const [activeSearch, setActiveSearch] = useState("");

// 	// Determine user role
// 	const isSuperAdmin = auth?.user?.role === "SUPER_ADMIN";
//   	const isAdmin = auth?.user?.role !== "SUPER_ADMIN";
// 	const clientId = auth?.user?.clientId;

// 	// Fetch all clients for SUPER_ADMIN
// 	const { 
// 		data: allClientsResponse, 
// 		isLoading: isLoadingAllClients, 
// 		error: allClientsError 
// 	} = useGetAllClients({
// 		page: currentPage,
// 		size: 10,
// 		search: activeSearch,
// 	}, {
// 		enabled: isSuperAdmin,
// 	});

// 	// Fetch single client for ADMIN
// 	const { 
// 		data: singleClientResponse, 
// 		isLoading: isLoadingSingleClient, 
// 		error: singleClientError 
// 	} = useGetClientById(clientId, {
// 		enabled: isAdmin && !!clientId,
// 	});

// 	// Determine which data to use based on role
// 	const clients = isSuperAdmin 
// 		? (allClientsResponse?.data || [])
// 		: (singleClientResponse?.data ? [singleClientResponse.data] : []);
	
// 	const pagination = isSuperAdmin 
// 		? (allClientsResponse?.pagination || {
// 			page: 1,
// 			size: 10,
// 			total: 0,
// 			totalPages: 1,
// 		})
// 		: {
// 			page: 1,
// 			size: 1,
// 			total: clients.length,
// 			totalPages: 1,
// 		};

// 	const isLoading = isSuperAdmin ? isLoadingAllClients : isLoadingSingleClient;
// 	const error = isSuperAdmin ? allClientsError : singleClientError;

// 	// Handle search input change
// 	const handleSearchInputChange = (e) => {
// 		setSearchInput(e.target.value);
// 	};

// 	// Handle search execution
// 	const handleSearch = () => {
// 		setActiveSearch(searchInput);
// 		setCurrentPage(1);
// 	};

// 	// Handle clear search
// 	const handleClearSearch = () => {
// 		setSearchInput("");
// 		setActiveSearch("");
// 		setCurrentPage(1);
// 	};

// 	// Handle Enter key press
// 	const handleKeyDown = (e) => {
// 		if (e.key === "Enter") {
// 			handleSearch();
// 		}
// 	};

// 	// Handle page change
// 	const onPageChange = (page) => {
// 		setCurrentPage(page);
// 	};

// 	// Format date helper
// 	function handleDate(date) {
// 		if (date == null) return "N/A";
// 		const validDate = parseISO(date, "yyyy-MM-dd", new Date());
// 		if (isValid(validDate))
// 			return format(new Date(date), "yyyy-MM-dd hh:mm:ss");
// 		return "N/A";
// 	}

// 	// Handle edit client
// 	const handleEdit = (e, event) => {
// 		e.preventDefault();
// 		setClient(event);
// 		setOpen(true);
// 	};

// 	// Handle error display
// 	if (error && !isLoading) {
// 		toast({
// 			variant: "destructive",
// 			title: "Error",
// 			description: error?.response?.data?.message || "Failed to load clients",
// 		});
// 	}

// 	return (
// 		<>
// 			<div className="overflow-hidden">
// 				<Card>
// 					<CardHeader>
// 						<CardTitle className="my-[10px]">
// 							{isSuperAdmin ? "List of all clients" : "Client Details"}
// 						</CardTitle>
// 						<CardDescription className="flex gap-[10px] w-[60vw]">
// 							{/* Only show search for SUPER_ADMIN */}
// 							{isSuperAdmin && (
// 								<div className="relative flex items-center w-[25vw] border border-grey-300 rounded-md">
// 									<Input
// 										className="w-[25vw] pr-12"
// 										placeholder="Search clients by name..."
// 										value={searchInput}
// 										onChange={handleSearchInputChange}
// 										onKeyDown={handleKeyDown}
// 									/>
// 									<button
// 										type="button"
// 										className="absolute right-2 bg-primary text-white rounded-md p-1.5 disabled:bg-primary/60"
// 										onClick={handleSearch}
// 										disabled={isLoading}
// 									>
// 										{isLoading ? (
// 											<ClipLoader color="white" size={14} />
// 										) : (
// 											<IoSearchOutline size={16} />
// 										)}
// 									</button>
// 									{/* {activeSearch && (
// 										<button
// 											type="button"
// 											className="absolute right-2 text-gray-500 hover:text-gray-700 p-1"
// 											onClick={handleClearSearch}
// 											title="Clear search"
// 										>
// 											✕
// 										</button>
// 									)} */}
// 								</div>
// 							)}
							
// 							{/* Only show New Client button for SUPER_ADMIN */}
// 							{isSuperAdmin && (
// 								<Sheet>
// 									<SheetTrigger asChild>
// 										<Button variant="outline">
// 											New Client
// 										</Button>
// 									</SheetTrigger>
// 									<SheetContent>
// 										<SheetHeader>
// 											<SheetTitle>
// 												Client Onboarding
// 											</SheetTitle>
// 											<SheetDescription>
// 												Search for a registered client
// 												email, then click the submit.
// 											</SheetDescription>
// 										</SheetHeader>
// 										<NewClient />
// 									</SheetContent>
// 								</Sheet>
// 							)}
							
// 							<Button variant="outline">
// 								<NavLink to={'/onboard-products'} className={'link'}>
// 									Update Products
// 								</NavLink>
// 							</Button>
// 							<Button variant="outline">
// 								<NavLink to={'/onboard-locations'} className={'link'}>
// 									Update Locations
// 								</NavLink>
// 							</Button>
// 						</CardDescription>
// 					</CardHeader>
					
// 					<CardContent className="space-y-2">
// 						<Table>
// 							<TableCaption>
// 								{pagination.total > 0
// 									? `Showing ${clients.length} of ${pagination.total} client(s)${isSuperAdmin ? ` - Page ${pagination.page} of ${pagination.totalPages}` : ''}`
// 									: "No clients found"}
// 							</TableCaption>
// 							<TableHeader>
// 								<TableRow>
// 									<TableHead>Client Name</TableHead>
// 									<TableHead>Email</TableHead>
// 									<TableHead>Date Created</TableHead>
// 									<TableHead className="text-center">
// 										IS NAFDAC MANDATE
// 									</TableHead>
// 									<TableHead className="text-right">
// 										Actions
// 									</TableHead>
// 								</TableRow>
// 							</TableHeader>
// 							<TableBody>
// 								{isLoading && (
// 									<TableRow>
// 										<TableCell colSpan={5}>
// 											<div className="h-[20vh] place-content-center text-center">
// 												<ClipLoader />
// 											</div>
// 										</TableCell>
// 									</TableRow>
// 								)}
								
// 								{!isLoading && clients.length === 0 && (
// 									<TableRow>
// 										<TableCell colSpan={5} className="text-center h-[20vh]">
// 											{isSuperAdmin && activeSearch
// 												? "No clients match your search"
// 												: "No client data available"}
// 										</TableCell>
// 									</TableRow>
// 								)}
								
// 								{!isLoading &&
// 									clients.map((client) => (
// 										<TableRow key={client.id}>
// 											<TableCell className="font-medium">
// 												{client?.clientName}
// 											</TableCell>
// 											<TableCell>
// 												{client?.email}
// 											</TableCell>
// 											<TableCell>
// 												{handleDate(client?.createdAt)}
// 											</TableCell>
// 											<TableCell className="text-center">
// 												{client.isNafdac === 1 || client.isNafdac === true
// 													? "YES"
// 													: "NO"}
// 											</TableCell>
// 											<TableCell className="text-right">
// 												<Button
// 													variant="link"
// 													onClick={(e) => handleEdit(e, client)
// 													// 	toast({
// 													// 	variant: "success",
// 													// 	title: "Info",
// 													// 	description: "Feature coming soon!",
// 													// })
// 												}
// 												>
// 													view
// 												</Button>
// 											</TableCell>
// 										</TableRow>
// 									))}
// 							</TableBody>
// 							<TableFooter>
// 								<TableRow>
// 									<TableCell colSpan={5}>
// 										Total: {pagination.total} client(s)
// 									</TableCell>
// 								</TableRow>
// 								{isSuperAdmin && pagination.totalPages > 1 && (
// 									<TableRow>
// 										<TableCell colSpan={5}>
// 											<Paginator
// 												currentPage={pagination.page}
// 												disabled={isLoading}
// 												onPageChange={onPageChange}
// 												pageCount={pagination.totalPages}
// 											/>
// 										</TableCell>
// 									</TableRow>
// 								)}
// 							</TableFooter>
// 						</Table>
// 					</CardContent>
// 					<CardFooter></CardFooter>
// 				</Card>
// 			</div>
// 		</>
// 	);
// }

// export default Client;





import React, { useState } from "react";
import {
	Card,
	CardContent,
	CardDescription,
	CardFooter,
	CardHeader,
	CardTitle,
} from "../components/ui/card";
import {
	Table,
	TableBody,
	TableCaption,
	TableCell,
	TableFooter,
	TableHead,
	TableHeader,
	TableRow,
} from "../components/ui/table";
import { Button } from "../components/ui/button";
import { format, isValid, parseISO } from "date-fns";
import {
	Sheet,
	SheetContent,
	SheetDescription,
	SheetHeader,
	SheetTitle,
	SheetTrigger,
} from "../components/ui/sheet";
import { Input } from "../components/ui/input";
import EditClient from "./EditClient";
import NewClient from "../components/NewClient";
import { useToast } from "../components/ui/use-toast";
import { ClipLoader } from "react-spinners";
import Paginator from "../components/Paginator";
import { useGetAllClients, useGetClientById } from "../migration-api/api-hooks/clients";
import { NavLink } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import { IoSearchOutline } from "react-icons/io5";
import TradingPartnersPopover from "../components/Tradingpartnerspopover";

function Client() {
	const [open, setOpen] = useState(false);
	const [client, setClient] = useState();
	const [tradingPartnersOpen, setTradingPartnersOpen] = useState(false);
	const [selectedClient, setSelectedClient] = useState(null);
	const { toast } = useToast();
	const { auth } = useAuth();
	
	// Pagination and filter state
	const [currentPage, setCurrentPage] = useState(1);
	const [searchInput, setSearchInput] = useState("");
	const [activeSearch, setActiveSearch] = useState("");

	// Determine user role
	const isSuperAdmin = auth?.user?.role === "SUPER_ADMIN";
  	const isAdmin = auth?.user?.role !== "SUPER_ADMIN";
	const clientId = auth?.user?.clientId;

	// Fetch all clients for SUPER_ADMIN
	const { 
		data: allClientsResponse, 
		isLoading: isLoadingAllClients, 
		error: allClientsError 
	} = useGetAllClients({
		page: currentPage,
		size: 10,
		search: activeSearch,
	}, {
		enabled: isSuperAdmin,
	});

	// Fetch single client for ADMIN
	const { 
		data: singleClientResponse, 
		isLoading: isLoadingSingleClient, 
		error: singleClientError 
	} = useGetClientById(clientId, {
		enabled: isAdmin && !!clientId,
	});

	// Determine which data to use based on role
	const clients = isSuperAdmin 
		? (allClientsResponse?.data || [])
		: (singleClientResponse?.data ? [singleClientResponse.data] : []);
	
	const pagination = isSuperAdmin 
		? (allClientsResponse?.pagination || {
			page: 1,
			size: 10,
			total: 0,
			totalPages: 1,
		})
		: {
			page: 1,
			size: 1,
			total: clients.length,
			totalPages: 1,
		};

	const isLoading = isSuperAdmin ? isLoadingAllClients : isLoadingSingleClient;
	const error = isSuperAdmin ? allClientsError : singleClientError;

	// Handle search input change
	const handleSearchInputChange = (e) => {
		setSearchInput(e.target.value);
	};

	// Handle search execution
	const handleSearch = () => {
		setActiveSearch(searchInput);
		setCurrentPage(1);
	};

	// Handle clear search
	const handleClearSearch = () => {
		setSearchInput("");
		setActiveSearch("");
		setCurrentPage(1);
	};

	// Handle Enter key press
	const handleKeyDown = (e) => {
		if (e.key === "Enter") {
			handleSearch();
		}
	};

	// Handle page change
	const onPageChange = (page) => {
		setCurrentPage(page);
	};

	// Format date helper
	function handleDate(date) {
		if (date == null) return "N/A";
		const validDate = parseISO(date, "yyyy-MM-dd", new Date());
		if (isValid(validDate))
			return format(new Date(date), "yyyy-MM-dd hh:mm:ss");
		return "N/A";
	}

	// Handle edit client
	const handleEdit = (e, event) => {
		e.preventDefault();
		setClient(event);
		setOpen(true);
	};

	// Handle view trading partners
	const handleViewTradingPartners = (e, client) => {
		e.preventDefault();
		setSelectedClient(client);
		setTradingPartnersOpen(true);
	};

	// Handle error display
	if (error && !isLoading) {
		toast({
			variant: "destructive",
			title: "Error",
			description: error?.response?.data?.message || "Failed to load clients",
		});
	}

	return (
		<>
			<div className="overflow-hidden">
				<Card>
					<CardHeader>
						<CardTitle className="my-[10px]">
							{isSuperAdmin ? "List of all clients" : "Client Details"}
						</CardTitle>
						<CardDescription className="flex gap-[10px] w-[60vw]">
							{/* Only show search for SUPER_ADMIN */}
							{isSuperAdmin && (
								<div className="relative flex items-center w-[25vw] border border-grey-300 rounded-md">
									<Input
										className="w-[25vw] pr-12"
										placeholder="Search clients by name..."
										value={searchInput}
										onChange={handleSearchInputChange}
										onKeyDown={handleKeyDown}
									/>
									<button
										type="button"
										className="absolute right-2 bg-primary text-white rounded-md p-1.5 disabled:bg-primary/60"
										onClick={handleSearch}
										disabled={isLoading}
									>
										{isLoading ? (
											<ClipLoader color="white" size={14} />
										) : (
											<IoSearchOutline size={16} />
										)}
									</button>
								</div>
							)}
							
							{/* Only show New Client button for SUPER_ADMIN */}
							{isSuperAdmin && (
								<Sheet>
									<SheetTrigger asChild>
										<Button variant="outline">
											New Client
										</Button>
									</SheetTrigger>
									<SheetContent>
										<SheetHeader>
											<SheetTitle>
												Client Onboarding
											</SheetTitle>
											<SheetDescription>
												Search for a registered client
												email, then click the submit.
											</SheetDescription>
										</SheetHeader>
										<NewClient />
									</SheetContent>
								</Sheet>
							)}
							
							<Button variant="outline">
								<NavLink to={'/onboard-products'} className={'link'}>
									Update Products
								</NavLink>
							</Button>
							<Button variant="outline">
								<NavLink to={'/onboard-locations'} className={'link'}>
									Update Locations
								</NavLink>
							</Button>
						</CardDescription>
					</CardHeader>
					
					<CardContent className="space-y-2">
						<Table>
							<TableCaption>
								{pagination.total > 0
									? `Showing ${clients.length} of ${pagination.total} client(s)${isSuperAdmin ? ` - Page ${pagination.page} of ${pagination.totalPages}` : ''}`
									: "No clients found"}
							</TableCaption>
							<TableHeader>
								<TableRow>
									<TableHead>Client Name</TableHead>
									<TableHead>Email</TableHead>
									<TableHead>Date Created</TableHead>
									<TableHead className="text-center">
										IS NAFDAC MANDATE
									</TableHead>
									<TableHead className="text-right">
										Actions
									</TableHead>
								</TableRow>
							</TableHeader>
							<TableBody>
								{isLoading && (
									<TableRow>
										<TableCell colSpan={5}>
											<div className="h-[20vh] place-content-center text-center">
												<ClipLoader />
											</div>
										</TableCell>
									</TableRow>
								)}
								
								{!isLoading && clients.length === 0 && (
									<TableRow>
										<TableCell colSpan={5} className="text-center h-[20vh]">
											{isSuperAdmin && activeSearch
												? "No clients match your search"
												: "No client data available"}
										</TableCell>
									</TableRow>
								)}
								
								{!isLoading &&
									clients.map((client) => (
										<TableRow key={client.id}>
											<TableCell className="font-medium">
												{client?.clientName}
											</TableCell>
											<TableCell>
												{client?.email}
											</TableCell>
											<TableCell>
												{handleDate(client?.createdAt)}
											</TableCell>
											<TableCell className="text-center">
												{client.isNafdac === 1 || client.isNafdac === true
													? "YES"
													: "NO"}
											</TableCell>
											<TableCell className="text-right">
												<Button
													variant="link"
													onClick={(e) => handleViewTradingPartners(e, client)}
												>
													view
												</Button>
											</TableCell>
										</TableRow>
									))}
							</TableBody>
							<TableFooter>
								<TableRow>
									<TableCell colSpan={5}>
										Total: {pagination.total} client(s)
									</TableCell>
								</TableRow>
								{isSuperAdmin && pagination.totalPages > 1 && (
									<TableRow>
										<TableCell colSpan={5}>
											<Paginator
												currentPage={pagination.page}
												disabled={isLoading}
												onPageChange={onPageChange}
												pageCount={pagination.totalPages}
											/>
										</TableCell>
									</TableRow>
								)}
							</TableFooter>
						</Table>
					</CardContent>
					<CardFooter></CardFooter>
				</Card>
			</div>

			{/* Trading Partners Popover */}
			<TradingPartnersPopover
				open={tradingPartnersOpen}
				onOpenChange={setTradingPartnersOpen}
				client={selectedClient}
			/>
		</>
	);
}

export default Client;